export const SET_DEVICE =((state, device) =>  {
    state.device = device
})
export const SET_DEVICE_PIXEL =((state, pixel) =>  {
    state.pixel = pixel
})